import announcementTypes from 'dashboard/actions/announcements/announcement-types';
import { setSelectedLanguage } from 'utils/actions/selected-language/selected-language.actions';

import template from './active-announcements.html';

const mapStateToThis = ({ announcements }) => {
  const { isLoading, active } = announcements;

  return {
    isLoading,
    active,
  };
};

const mapDispatchToThis = {
  setSelectedLanguage,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'Notifications')
class ActiveAnnouncementsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.type = announcementTypes.ACTIVE;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onNewAnnouncement() {
    this.$state.go('cms-editNewsManagement', {
      skipDirtyForms: true,
    });
  }

  onPreviewAnnouncements() {
    this.Notifications.showComplexDialog({
      component: 'announcementPreview',
    });
  }

  onLanguageSelect(locale) {
    this.setSelectedLanguage(locale);
  }
}

export default class ActiveAnnouncementsComponent {
  constructor() {
    this.template = template;
    this.controller = ActiveAnnouncementsController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/active-announcements/active-announcements-component.js